import React from 'react';
import headerImage from '../../header.png';

export default function Hero() {
  return (
    <section className="text-center py-20 px-4">
      <h1 className="text-5xl font-black text-gray-900 font-space-grotesk">
        <img src={headerImage} alt="Clingfilm Header" className="mx-auto max-w-full h-auto" />
      </h1>
      <p className="mt-4 text-lg text-white max-w-xl mx-auto">
        Escape the tyranny of the lizards. Train your own film and TV reccomendations.
      </p>
    </section>
  );
}
